var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('el-row',[_c('el-col',{attrs:{"span":_vm.spanTitle}},[_c('div',{staticClass:"input-title"},[_vm._v("出品価格")])]),_c('el-col',{attrs:{"span":_vm.spanSetting}},[_c('div',{staticClass:"label-area"},[_vm._v(_vm._s(_vm.value)+"円")])])],1)}
var staticRenderFns = []

export { render, staticRenderFns }